import { render, staticRenderFns } from "./manageQuestionsTemplate.vue?vue&type=template&id=6652c7ef"
import script from "./manageQuestionsTemplate.vue?vue&type=script&lang=js"
export * from "./manageQuestionsTemplate.vue?vue&type=script&lang=js"
import style0 from "./manageQuestionsTemplate.vue?vue&type=style&index=0&id=6652c7ef&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports